module.exports = __webpack_public_path__ + "static/portfolio-5-8b6382721691a89775030723de15500b.jpg";